import currencyData from "constants/currencyConstants";

const getCurrencySymbol = (currency: any) =>
  currencyData.find(({ short_name, standard_name }: any) =>
    [short_name.toLowerCase(), standard_name.toLowerCase()].includes(
      (currency || "").toLowerCase(),
    ),
  )?.symbol || "";
export default getCurrencySymbol;
